<template>
    <!--Waiting List Dashboard-->
    <div class="waiting-list-dashboard">
        <div class="wlist-dashboard-container">
            <!--Heading title-->
            <h3>{{ $ml.get("waitingListDashboard.title") }}</h3>
            <!--Dashboard content-->
            <div class="wlist-dashboard-content section-wrap">
                <router-link :to="{ path: '/app/waiting-list/dashboard/clients' }">
                    {{ $ml.get("waitingListDashboard.currentWaitlist") }}
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/invite-clients' }">
                    {{ $ml.get("waitingListDashboard.inviteClients") }} - <span> {{
                        $ml.get("waitingListDashboard.inviteMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/notifications' }">
                    {{ $ml.get("waitingListDashboard.notifications") }} - <span>{{
                        $ml.get("waitingListDashboard.notificationsMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/transactions' }">
                    {{ $ml.get("waitingListDashboard.transactions") }} - <span>{{
                        $ml.get("waitingListDashboard.transactionsMessage") }}</span>
                </router-link>
                <router-link :to="{ path: '/app/waiting-list/dashboard/settings' }">
                    {{ $ml.get("waitingListDashboard.settings") }} - <span>{{
                        $ml.get("waitingListDashboard.settingsMessage") }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {};
    },
    computed: {},
    mounted() { },
    components: {},
    methods: {},

};
</script>
